function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fapy9d3wea"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 117114",
    style: {
      fill: "#202020"
    },
    d: "M0 0h34.181v40.978H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 137210"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 137197"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 137196",
    transform: "translate(10.577 7.51)",
    style: {
      clipPath: "url(#fapy9d3wea)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121128",
    d: "M30.763 30.723H3.418v-2.314a5.09 5.09 0 0 1 3.65-4.9 9.256 9.256 0 0 0 6.983-8.123H3.418v-1.669a5.151 5.151 0 0 1 3.264-4.774C9.844 7.66 11.792 6.06 12.977 1.3L13.3 0h1.334c15.944 0 16.129 14.382 16.129 14.527zm3.418 10.255H0v-1.709a5.128 5.128 0 0 1 5.127-5.127h23.927a5.128 5.128 0 0 1 5.127 5.127z",
    style: {
      fill: "#202020"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogic);
export default __webpack_public_path__ + "static/media/icon_logic.a666f05ce2e07f7b7a303fb235f0f903.svg";
export { ForwardRef as ReactComponent };